'use client';

import { useTranslations } from 'next-intl';
import { CatDropdown, CatList, CatListItem } from '../blocks-components';
import { dropdownOptionType } from './types';
import { BlocksSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
export interface SortByDropdownProps {
  onChangeDropdown: (e: BlocksSelectEvent) => void;
  dropdownOptions: dropdownOptionType[];
  sortBy: string;
}

const SortByDropdown = ({
  onChangeDropdown,
  dropdownOptions,
  sortBy
}: SortByDropdownProps) => {
  const t = useTranslations();
  const placeHolder =
    t(dropdownOptions.find((option) => option.value === sortBy)?.label) ?? '';

  return (
    <CatDropdown
      data-testid="sort-by-dropdown"
      fieldId="sort-by-dropdown"
      value={sortBy}
      onBlSelect={(e: BlocksSelectEvent) => {
        onChangeDropdown(e);
      }}
      hideLabel={true}
      size="md"
      placeholder={placeHolder}
    >
      <CatList>
        {dropdownOptions.map(({ value, label }) => (
          <CatListItem key={value} value={{ value, label }}>
            {t(label)}
          </CatListItem>
        ))}
      </CatList>
    </CatDropdown>
  );
};

export default SortByDropdown;
